import { FormViewField } from 'components/FormView';

interface IFilterConfig {
  component: any;
  fields: string[];
}

export function getFilterByProgram(program?: string): IFilterConfig | null {
  if (!program) return null;

  const map: Record<
    string,
    {
      component: any;
      fields: string[];
    }
  > = {
    Transactions: {
      component: CETFilterRow,
      fields: ['TransactionOption', 'TransactionType', 'FromDate', 'ToDate', 'EntityView', 'Entity', 'Invoice']
    },
    Invoices: {
      component: CustomerInvoiceFilters,
      fields: ['TransactionOption', 'TransactionType', 'FromDate', 'ToDate', 'EntityView', 'Entity', 'CustomerPO']
    }
  };

  return map[program] ?? null;
}

export const CETFilterRow = {
  formName: 'CETFilters',
  validate: null,
  rowModelType: 'serverSide',
  parameters: [
      {
        id: 0,
        type: 'EX_LOOKUP_FIELD',
        props: {
          label: 'Entity view',
          name: 'EntityView',
          lookupName: 'EntityView',
          size: 'small',
          required: true
        }
      },
      {
        id: 1,
        type: 'EX_LOOKUP_FIELD',
        props: {
          label: 'Entity',
          name: 'Entity',
          lookupName: 'SalesEntity',
          size: 'small',
          required: false
        }
      },
      {
        id: 2,
        type: 'AUTOCOMPLETE_FIELD',
        props: {
          label: 'Transaction type',
          name: 'TransactionType',
          required: false,
          apiPrefs: {
            path: '/CustomTypes/Lookup/TransactionType/Search',
            method: 'POST',
            params: {
              BatchSize: 20
            }
          },
        }
      },
      {
        id: 3,
        type: 'AUTOCOMPLETE_FIELD',
        props: {
          label: 'Show',
          name: 'TransactionOption',
          required: false,
          options: [
            {
              value: 'All',
              label: 'All'
            },
            {
              value: 'Outstanding',
              label: 'Outstanding'
            },
            {
              value: 'Current',
              label: 'Current'
            },
            {
              value: 'Finalised',
              label: 'Finalised'
            }
          ]
        }
      },
      {
        id: 4,
        type: 'DATE_FIELD',
        props: {
          label: 'Date range from',
          name: 'FromDate',
          required: false,
          dateFormat: 'DD/MM/YYYY',
          placeholder: 'DD/MM/YYYY',
          nullable: 'true',
          size: 'small',
          style: {
            display: 'inline-block',
            width: '155px',
            marginRight: '16px'
          }
        }
      },
      {
        id: 4,
        type: 'DATE_FIELD',
        props: {
          label: 'To',
          name: 'ToDate',
          required: false,
          dateFormat: 'DD/MM/YYYY',
          placeholder: 'DD/MM/YYYY',
          nullable: 'true',
          size: 'small',
          style: {
            display: 'inline-block',
            width: '155px',
            marginRight: '16px'
          }
        }
      },
      {
        id: 5,
        type: 'TEXT_FIELD',
        props: {
          label: 'Invoice',
          name: 'Invoice',
          size: 'small',
          required: false
        }
      },
    ] as FormViewField[]
};

export const CustomerInvoiceFilters = {
    formName: 'CustomerInvoiceFilters',
    validate: null,
    parameters: [
      {
        id: 0,
        type: 'EX_LOOKUP_FIELD',
        props: {
          label: 'Entity View',
          name: 'EntityView',
          lookupName: 'EntityView',
          size: 'small',
          required: true
        }
      },
      {
        id: 1,
        type: 'EX_LOOKUP_FIELD',
        props: {
          label: 'Entity',
          name: 'Entity',
          lookupName: 'SalesEntity',
          size: 'small',
          required: false
        }
      },
      {
        id: 2,
        type: 'AUTOCOMPLETE_FIELD',
        props: {
          label: 'Invoice type',
          name: 'TransactionType',
          defaultValue: 'All',
          required: false,
          options: [
            {
              value: 'All',
              label: 'All'
            },
            {
              value: 'Invoice',
              label: 'Invoice'
            },
            {
              value: 'Credit note',
              label: 'Credit note'
            }
          ]
        }
      },
      {
        id: 3,
        type: 'AUTOCOMPLETE_FIELD',
        props: {
          label: 'Show',
          name: 'TransactionOption',
          defaultValue: 'Yes',
          required: false,
          options: [
            {
              value: 'All',
              label: 'All'
            },
            {
              value: 'Yes',
              label: 'Updated'
            },
            {
              value: 'No',
              label: 'Not Updated'
            }
          ]
        }
      },
      {
        id: 4,
        type: 'DATE_FIELD',
        props: {
          label: 'Date range from',
          name: 'FromDate',
          required: false,
          dateFormat: 'DD/MM/YYYY',
          placeholder: 'DD/MM/YYYY',
          nullable: 'true',
          size: 'small',
          style: {
            display: 'inline-block',
            width: '155px',
            marginRight: '16px'
          }
        }
      },
      {
        id: 5,
        type: 'DATE_FIELD',
        props: {
          label: 'To',
          name: 'ToDate',
          required: false,
          dateFormat: 'DD/MM/YYYY',
          placeholder: 'DD/MM/YYYY',
          nullable: 'true',
          size: 'small',
          style: {
            display: 'inline-block',
            width: '155px',
            marginRight: '16px'
          }
        }
      },
      {
        id: 5,
        type: 'TEXT_FIELD',
        props: {
          label: 'Customer P/O',
          name: 'CustomerPO',
          size: 'medium',
          required: false,
        }
      },
    ] as FormViewField[]
  };
